import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { AccessLogsTable } from '@/features/logs-management/access-logs/table';
import { useAccessLogs } from '@/features/logs-management/hooks/useAccessLogs';
import { logQueries } from '@/services/logsManagement/logsManagement.queries';
import { SearchSchemaInput, createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['pageName', 'userInfo', 'browser', 'statusCode', 'ipAddress', 'createdDate']),
  desc: z.boolean(),
});

const accessLogsSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),

  q: z.string().optional(),

  page: z.coerce.number().positive().catch(1),
});

export const Route = createFileRoute('/(app)/logs-management/access-logs/')({
  loader: async ({ context: ctx }) => {
    const queryOptions = logQueries.access;
    const actualQueryFn = queryOptions.queryFn(ctx.client);
    const accessLogs = await ctx.queryClient.ensureQueryData({
      ...queryOptions,
      queryFn: actualQueryFn,
    });
    return {
      crumb: <CrumbTitle title="Access Logs" />,
      title: 'Access Logs',
      accessLogs,
    };
  },
  errorComponent: ({ error }) => {
    return <div>{error.message}</div>;
  },
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => accessLogsSchema.parse(search),
});

function RouteComponent() {
  const { accessLogs } = useAccessLogs();
  return <AccessLogsTable data={accessLogs} />;
}
